export default function TrackingOrderInfo({ tracking, orderId, tt }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border p-5" data-testid="tracking-order-info">
      <h3 className="font-bold text-gray-900 mb-3">{tt("orderDetails")}</h3>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-500">{tt("order")}</span>
          <span className="font-mono font-bold">#{orderId.slice(-6).toUpperCase()}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">{tt("items")}</span>
          <span>{tracking.items_count} {tt("products")}</span>
        </div>
        {tracking.delivery_address && (
          <div className="flex justify-between">
            <span className="text-gray-500">{tt("address")}</span>
            <span className="text-right max-w-[200px]">{tracking.delivery_address}</span>
          </div>
        )}
        <div className="flex justify-between pt-2 border-t">
          <span className="font-bold">{tt("total")}</span>
          <span className="font-bold text-emerald-700 text-lg">{(tracking.total || 0).toFixed(2)} EUR</span>
        </div>
      </div>
    </div>
  );
}
